import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {khanmigoCoeditingAutosaveType} from "./__graphql-types__/index.ts";

export const SAVE_SNAPSHOT_MUTATION: GqlOperation<
    khanmigoCoeditingAutosaveType["response"],
    khanmigoCoeditingAutosaveType["variables"]
> = gqlOp(gql`
    mutation khanmigoCoeditingAutosave(
        $configName: String!
        $threadId: String!
        $title: String!
        $jsonData: String!
        $persona: AIGuidePersona!
    ) {
        saveCoeditingV2Snapshot(
            configName: $configName
            threadId: $threadId
            title: $title
            jsonData: $jsonData
            persona: $persona
        ) {
            error {
                code
            }
        }
    }
`);
